/* SÉRAINE — interactions légères et robustes (sans dépendance) */
(function () {
  'use strict';

  // Header : état "scrolled"
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Menu mobile (drawer)
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeBtn = document.querySelector('[data-drawer-close]');
  if (drawer && openBtn) {
    var open = function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // Sélecteurs de quantité (produit + panier)
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var val = parseInt(input.value, 10) || 1;
        val = Math.max(parseInt(input.min, 10) || 1, val + step);
        input.value = val;
        if (input.hasAttribute('data-autosubmit')) {
          var form = input.closest('form');
          if (form) form.submit();
        }
      });
    });
  });
})();
